// extracted by mini-css-extract-plugin
module.exports = {"splitLayout":"split-layout_splitLayout__6rMMc"};